

export default function Nomen({nomen, position, deleteClick}) {
    // states


    // comportements
    


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{nomen?.lib}</td>
            <td>{nomen?.abrev}</td>
            <td>{nomen?.codeparent ? nomen?.libparent : ""}</td>
            {/* <td><ReactTimeAgo date={Date.parse(nomen?.datecrea)} timeStyle="facebook" /></td> */}
            <td className="text-center">
                {/* <Link to={`/nomen/${nomen?.codenomenacces}`} data-toggle="tooltip" title="View nomenclature" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link> */}
                <button onClick={deleteClick} data-toggle="tooltip" title="Supprimer la nomenclature"  className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    )
}